export const environment = {
  production: false,
  version: '1.0',
  firebase: {
    // apiKey: 'AIzaSyAYth0O9ooc0C7uAmY9y15LcjK19VmN6i0',
    // authDomain: 'parcodisalice-test.firebaseapp.com',
    // databaseURL: 'https://parcodisalice-test-default-rtdb.europe-west1.firebasedatabase.app',
    // projectId: 'parcodisalice-test',
    // storageBucket: 'parcodisalice-test.appspot.com',
    // messagingSenderId: '688284342706',
    // appId: '1:688284342706:web:34b73089141f357fd9acab',
    // measurementId: 'G-V2LWS9RNRT'

    // prod
    apiKey: 'AIzaSyAmpUU-GJ5wO93_TBZHr2eEzR_V3dHq8BU',
    authDomain: 'parcodisalice.firebaseapp.com',
    databaseURL: 'https://parcodisalice-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'parcodisalice',
    storageBucket: 'parcodisalice.appspot.com',
    messagingSenderId: '37323276499',
    appId: '1:37323276499:web:5942c6d02fb87e64cd1426',
    measurementId: 'G-5B1CCZF77H'
  }
};

